import React, {useEffect} from "react";
import * as StorageService from "../services/StorageService.js";
import {LOCALSTORAGE_ITEMS, ORDER_PLACE} from "../util/Constants";
import {PATH} from "../routes/routes";
import {clearStorageItems, handleAppVersionUpdate} from "../util/common";
import {useNavigate} from "react-router";
import {useParams} from "react-router-dom";

function TableQrScan(props) {

    const navigateTo = useNavigate();

    const {shopName, userTable} = useParams();
    const decodedUserTable = decodeURIComponent(userTable);
    useEffect(() => {

        handleAppVersionUpdate();
        clearStorageItems();
        StorageService.removeItem(LOCALSTORAGE_ITEMS.CURRENT_CART);
        StorageService.setItem(LOCALSTORAGE_ITEMS.SHOP_NAME, shopName);
        StorageService.setItem(LOCALSTORAGE_ITEMS.USER_TABLE, decodedUserTable);
        StorageService.setItem(LOCALSTORAGE_ITEMS.ORDER_PLACE, ORDER_PLACE.TABLE);
        StorageService.setItem(LOCALSTORAGE_ITEMS.HAS_BACK_BUTTON, "false");
        navigateTo(PATH.ALL_PRODUCTS);

    }, []);

    return (
        <div className="redirect-msg">
            Redirecting to zoniz order app...
        </div>


    );
}

export default TableQrScan;
